import {FC, SVGProps} from 'react';
import {IndividualSuccessIcon, RegistrationSuccessIcon} from 'shared/assets/icons';
import {RegistrationWorkStatus} from './types';

export const MY_TAX_SUCCESS_ICONS: Record<RegistrationWorkStatus, FC<SVGProps<SVGSVGElement>>> = {
	self_employment: RegistrationSuccessIcon,
	individual: IndividualSuccessIcon,
	individual_entrepreneur: RegistrationSuccessIcon,
};

export const getMyTaxSuccessIcon = (workStatus: RegistrationWorkStatus | null): FC<SVGProps<SVGSVGElement>> => {
	if (!workStatus) {
		return MY_TAX_SUCCESS_ICONS.self_employment;
	}

	return MY_TAX_SUCCESS_ICONS[workStatus];
};
